export default {
  services: {
    autorizacoesUi: window.___bth.envs.suite['autorizacoes-ui'].stable.host,
    licencasApi: window.___bth.envs.suite.licenses.v1.host,
    suiteUi: {
      liberacaoLicenca: window.___bth.envs.suite['suite-ui']['liberacao-licenca'].host
    }
  }
}
